// Async Module Federation bootstrap shim
// Fetches the remote manifest, initializes MF shared singletons, then loads the app.
// The promise chain ensures shared modules (React, etc.) are negotiated before any
// component code runs — required by Module Federation.

import { getInstance } from "@module-federation/enhanced/runtime";

declare const __webpack_public_path__: string;

interface ManifestModule {
  url: string;
}

interface Manifest {
  modules: Record<string, ManifestModule>;
}

fetch(`${__webpack_public_path__}manifest.json`)
  .then((r) => r.json() as Promise<Manifest>)
  .catch((): Manifest => ({ modules: {} })) // fallback: no remotes, app still loads
  .then((manifest: Manifest) => {
    const instance = getInstance();
    if (instance === null) {
      throw new Error(
        "[MFE] ModuleFederation instance not found — ensure the build plugin is active."
      );
    }
    instance.registerRemotes(
      Object.entries(manifest.modules).map(([name, { url }]) => ({
        name,
        entry: url,
      }))
    );
  })
  .then(() => import("./bootstrap"))
  .catch((err: unknown) => {
    console.error("[MFE] Bootstrap failed to load:", err);
  });
